// extracted by mini-css-extract-plugin
module.exports = {"disclaimerBox":"styles_disclaimerBox__1nVkP","infoIconButton":"styles_infoIconButton__1ALjw","infoIcon":"styles_infoIcon__3Kumc"};